import {
    LOGIN_SUCCESS,
    SELECT_CUSTOMER,
    REFRESH_ACCESS,
    REFRESH_ACCESS_SUCCESS,
    REFRESH_ACCESS_FAIL,
    LOGOUT,
    LOGIN,
} from '../../constants/actions/auth.constants';
import { IUserState, IAction } from '../../types';
import { UserService } from '../../services/common/UserService';
import { GET_ACTIVE_QUESTIONNAIRES_SUCCESS } from '../../constants/actions/users.constants';
import QuestionnaireActions from '../../participant/actions/QuestionnaireActions';

const initialState = {
    accessToken: UserService.getAccessToken(),
    refreshToken: UserService.getRefreshToken(),
    isLoading: false,
    hasRefreshed: false,
    isLoggedIn: UserService.isLogged(),
    shouldRedirectToQuestionnaire: false,
    hasLoggedOut: false,
};

export function user(
    state: IUserState = initialState,
    { type, payload, error }: IAction,
) {
    switch (type) {
        case LOGIN:
            return { ...state, hasLoggedOut: false };
        case LOGIN_SUCCESS:
            return loginSuccess();
        case LOGOUT:
            return {
                ...state,
                isLoading: false,
                hasRefreshed: false,
                accessToken: null,
                refreshToken: null,
                isLoggedIn: false,
                shouldRedirectToQuestionnaire: false,
                hasLoggedOut: true,
            };
        case SELECT_CUSTOMER:
            return {
                ...state,
                accessToken: payload.accessToken,
                refreshToken: payload.refreshToken,
                isLoggedIn: true,
                hasLoggedOut: false,
            };
        case REFRESH_ACCESS:
            return { ...state, isLoading: true, hasRefreshed: false };
        case REFRESH_ACCESS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasRefreshed: true,
                accessToken: payload.accessToken,
                refreshToken: payload.refreshToken,
            };
        case REFRESH_ACCESS_FAIL:
            return {
                ...state,
                isLoading: false,
                hasRefreshed: false,
                isLoggedIn: false,
                error,
            };
        case GET_ACTIVE_QUESTIONNAIRES_SUCCESS:
            if (payload && payload.length > 0) {
                return {
                    ...state,
                    shouldRedirectToQuestionnaire: true,
                };
            }

            return state;
        case QuestionnaireActions.closeQuestionnaire.type:
            return {
                ...state,
                shouldRedirectToQuestionnaire: false,
            };
        default:
            return state;
    }

    function loginSuccess() {
        if (Array.isArray(payload) && payload.length === 1) {
            const { accessToken, refreshToken } = payload[0];
            return { ...state, accessToken, refreshToken, isLoggedIn: true };
        }

        return state;
    }
}
